// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"482":"911c1300","544":"8de26626"}[chunkId] + ".css";
};